import { createTheme, MantineColorsTuple } from '@mantine/core';

import cardClasses from './overrides/card.module.css';
import glassClasses from './overrides/glass.module.css';
import './global.css';
import { LoaderComponent } from '@/routes/lazy-page';

// Define custom purple color palette
const blueColors: MantineColorsTuple = [
  '#ffffff',  // lightest
  '#f0f8fc',  // nearly white blue
  '#c3ebfb',  // very light blue
  '#7bbee5',  // light blue
  '#649cbc',  // medium blue
  '#67829e',  // blue gray
  '#0d72b4',  // primary blue
  '#1885cc',  // slightly lighter variant
  '#3498db',  // light variant
  '#5dade2'   // lightest variant
];

export const theme = createTheme({
  cursorType: 'pointer',
  fontFamily: 'Inter, sans-serif',
  primaryColor: 'blue',
  defaultRadius: 'lg',
  colors: {
    blue: blueColors,
  },
  breakpoints: {
    xs: '30em',
    sm: '40em',
    md: '48em',
    lg: '64em',
    xl: '80em',
    '2xl': '96em',
    '3xl': '120em',
    '4xl': '160em',
  },
  components: {
    Card: {
      defaultProps: {
        classNames: cardClasses,
        radius: 'md',
        withBorder: true,
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
        shadow: 'xs',
        classNames: {
          root: glassClasses.glass,
        },
      },
    },
    Container: {
      defaultProps: {
        size: 'lg',
        py: 20,
      },
    },
    Title: {
      styles: {
        root: {
          '&[data-order="2"]': {
            fontSize: '2.25rem',
          },
        },
      },
    },
    Text: {
      styles: {
        root: {
          '&[data-dimmed="true"]': {
            opacity: 0.7,
          },
          '&[data-size="lg"]': {
            opacity: 0.8,
          },
        },
      },
    },
    Badge: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          textTransform: 'none',
        },
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
        loaderProps: {
          type: 'dots',
          color: 'white',
          size: 'sm',
        },
      },
      styles: {
        root: {
          transition: 'all 0.2s ease',
        },
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    NumberInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Tooltip: {
      defaultProps: {
        radius: 'md',
        disabled: typeof window !== 'undefined' ? window.innerWidth <= 1024 : false,
      },
    },
    Tabs: {
      defaultProps: {
        variant: 'pills',
        radius: 'md',
        color: 'grape',
        shadow: 'xl',
      },
    },
  },
});
